import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import FileDownload from "js-file-download";
import { getToken } from '../oidc/AuthService';
import { getCallWithReducer, postCallWithReducer } from "./commonAction";
import { DASHBOARD_WIDGET_A2D_FILTERS, DASHBOARD_WIDGET_ACTION_ITEM_REPORT, DASHBOARD_WIDGET_AVERAGE_SCORE_PER_CHAPTER, DASHBOARD_WIDGET_DEALER_NETWORK_STATUS, DASHBOARD_WIDGET_DEALER_PROGRESS_PER_LOCATION, DASHBOARD_WIDGET_KAIZEN_OVERVIEW, DASHBOARD_WIDGET_PROGRESS_PER_NMSC, DASHBOARD_WIDGET_SCORE_PER_SUBQUESTION } from '../AppConstant';
var I18n = require("react-redux-i18n").I18n;
/**
 * Fetch Available Toolboxes for User.
 */
export function fetchAvailableToolboxes(program, nmscCode, langCode) {
    return function (dispatch) {
        axios.get('/dashboard/toolboxes/' + program + '/' + nmscCode + '/' + langCode, {
            headers: {
            'Authorization': 'Bearer ' + getToken(),
            "Content-type": "application/json",
            'Accept': "application/json",
            'X-Frame-Options':"DENY",
                unblockUI: true
            }
        })
            .then(response => {
                if (response.data !== undefined) {
                    // console.log(response.data);
                    dispatch({
                        type: "SET_TOOLBOX_FILTER",
                        payload: response.data
                    })
                }
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    }
}

export function fetchAvailableKPIs(program, nmscCode, langCode, userId) {
    return function (dispatch) {
        axios.get('/dashboard/availableKPIs/' + program + '/' + nmscCode + '/' + langCode + '/' + userId, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                "Content-type": "application/json",
                'Accept': "application/json",
                unblockUI: true,
                Pragma: "no-cache",
                'X-Frame-Options':"DENY",
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Credentials": true,
            }
        })
            .then(response => {

                if (response.data !== undefined) {
                    // console.log(response.data);
                    dispatch({
                        type: "SET_AVAILABLE_KPIS",
                        payload: response.data
                    })
                }
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    }
}

/**
 * Fetch Widget Data.
 * 
 * @param {*} queryDTO 
 */
export function fetchScrollableWidgetData(widgetName, reducerName, queryDTO) {
    return function (dispatch) {
        axios.post('/dashboard/widget/' + widgetName, queryDTO,
            {
                headers: {
                    unblockUI: true,
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Pragma: "no-cache",
                    "X-Frame-Options":"DENY",
                    'Authorization': 'Bearer ' + getToken()
                }
            })
            .then(response => {
                if (response.data !== undefined) {
                    dispatch({
                        type: reducerName,
                        payload: response.data
                    })
                }
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    }
}

// export function fetchScrollableWidgetData(widgetName, reducerName, queryDTO) {
//     return function (dispatch) {
//     dispatch(postCallWithReducer('/dashboard/widget/' + widgetName, queryDTO,reducerName))
//     };
//   }

/**
 * Fetch Activity Status list.
 */
export function fetchActivityStatus() {
    return function (dispatch) {
        axios.get('/dashboard/activityStatus', {
            headers: {
                unblockUI: true,
                "Content-type": "application/json",
                Accept: "application/json",
                "X-Frame-Options":"DENY",
                'Authorization': 'Bearer ' + getToken()
            }
        })
            .then(response => {
                if (response.data !== undefined) {
                    dispatch({
                        type: "SET_ACTIVITY_STATUS",
                        payload: response.data
                    })
                }
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    }
}

export function fetchFilters(activityDto, program) {
    return function (dispatch) {
        //dispatch(setBlockingState(true));
        axios
            .post("/dashboard/searchFilters", activityDto, {
                headers: {
                    unblockUI: true,
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Pragma: "no-cache",
                    "X-Frame-Options":"DENY",
                    'Authorization': 'Bearer ' + getToken()
                }
            })
            .then(response => {
                dispatch({
                    type: "SET_FILTERS",
                    payload: response.data
                });
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    };
}

export function saveUserKpiPreference(data, queryDTO, program) {
    return function (dispatch) {
        axios
            .post("/dashboard/widget/saveKpiPreference/" + program + "/" + queryDTO.userNmscCode, data, {
                headers: {
                    unblockUI: true,
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Pragma: "no-cache",
                    "X-Frame-Options":"DENY",
                    'Authorization': 'Bearer ' + getToken()
                }
            })
            .then(response => {
                toastr.success("User Preference Saved.")
                // Recalculate Business Results.
                dispatch(fetchScrollableWidgetData("businessResults", "SET_BUSINESS_RESULTS", queryDTO));
                dispatch(fetchAvailableKPIs(queryDTO.programList, queryDTO.userNmscCode, queryDTO.userLangCode, queryDTO.userId))
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    };
}

export function filtersDashboard(selectedfilters, activeProgram, activityDto) {

    return function (dispatch) {
        dispatch({
            type: activeProgram + "_FILTER",
            payload: selectedfilters
        });

        dispatch({
            type: activeProgram + "_ACTIVITY_DTO",
            payload: activityDto
        });
    };
}

export function saveDealerPreference(data, program, userId, queryDTO) {
    return function (dispatch) {
        axios
            .post("/dashboard/widget/saveDealerPreference/" + program + "/" + userId + "/" + queryDTO.userNmscCode, data, {
                headers: {
                    unblockUI: true,
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Pragma: "no-cache",
                    "X-Frame-Options":"DENY",
                    'Authorization': 'Bearer ' + getToken()
                }
            })
            .then(response => {
                toastr.success("Dealer Preference Saved.")
                dispatch(fetchScrollableWidgetData("businessResults", "SET_BUSINESS_RESULTS", queryDTO));
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    };
}


export function getNoticeBoard(userId,program,businessArea) {
    return function (dispatch) {
        axios.get('/dashboard/widget/noticeBoard/' + program+ "/"+ userId +"/"+ businessArea, {
            headers: {
                unblockUI: true,
                "X-Frame-Options":"DENY",
                'Authorization': 'Bearer ' + getToken()
            }
        })
            .then(response => {
                if (response.data !== undefined) {
                    // console.log(response.data);
                    dispatch({
                        type: "NOTICE_BOARD",
                        payload: response.data
                    })
                }
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    }
}

export function getActionItemReport(queryDto) {
    return function (dispatch) {
        axios.post('/dashboard/widget/actionItemReport', queryDto, {
            headers: {
                unblockUI: true,
                "X-Frame-Options":"DENY",
                'Authorization': 'Bearer ' + getToken()
            }
        })
            .then(response => {
                if (response.data !== undefined) {
                    // console.log(response.data);
                    dispatch({
                        type: "ACTION_ITEM_REPORT",
                        payload: response.data
                    })
                }
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    toastr.error(error.message);
                }
            });
    }
}

export function downloadActionItem(dto, queryDto) {
    return function (dispatch) {
        var url = "/dashboard/widget/download";
        axios
            .post(url, queryDto, {
                contentType: "application/octet-stream",
                headers: {
                    Pragma: "no-cache",
                    "X-Frame-Options":"DENY",
                    'Authorization': 'Bearer ' + getToken()
                }
                ,
                responseType: "arraybuffer"
            })
            .then(function (response) {
                  let fileName = response.headers["filename"].replace("%2C", ",");
                  FileDownload(response.data, decodeURI(fileName.replace(/\+/g, " ")));
            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    console.error(error);
                }
            });
    };
}

export function fetchBestPractice(userMdl) {
    return function (dispatch) {
        var obj = {
            "userNmscCode": userMdl.nmsc,
            "userLangCode":userMdl.lang,
            "activeProgram":userMdl.activeProgram,
            "businessArea":userMdl.businessAreaKey
        }
        var url = "/dashboard/widget/fetchBestPractice";
        axios
            .post(url, obj, {
                headers: {
                    Pragma: "no-cache",
                    "X-Frame-Options":"DENY",
                    'Authorization': 'Bearer ' + getToken(),
                },
                responseType: "json/application"
            })
            .then(function (response) {
                if (response.data !== undefined) {
                    console.log(response.data)
                    // dispatch({
                    //     type: "BEST_PRACTICE",
                    //     payload: response.data
                    // })
                }

            })
            .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    console.error(error);
                }
            });
    };
}

/**
 * Fetch ReachIT monthly file data
 */
 export function getMonthlyUploadedFilesData(userRole) {
    return function (dispatch) {
      //dispatch(setBlockingState(true));
      axios
        .get("/monthlyFileUpload/monthlyUploadedFilesData/" +userRole, {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Pragma: "no-cache",
            "X-Frame-Options":"DENY",
            'Authorization': 'Bearer ' + getToken()
          }
        })
        .then(response => {
            console.log("response",response)
          //dispatch(setBlockingState(false));
          dispatch({
            type: "MONTHLY_FILE_DATA",
            payload: response.data
          });
        })
        .catch(function (error) {
            if (error && error.status && (error.status === 429)) {
            } else {
                console.error(error);
            }
        });
    };
  }

  export function downloadMonthlyFile(obj, fileDto) {
    return function (dispatch) {
        var preSignedURL = obj.desc;
        axios({
        method: 'get',
        contentType: "application/octet-stream",
        url: preSignedURL,
        responseType: 'arraybuffer',
        headers: { 'Pragma': 'no-cache', 'X-Frame-Options':'DENY' }
        }).then(function (response) {
            FileDownload(response.data, obj.body.replace(/%20/g, " "));
        })        
        dispatch(saveFileDownloadData(fileDto));      
    };
  }

  export function saveFileDownloadData(fileDto) {
    return function (dispatch) {     
      axios
        .post("/monthlyFileUpload/saveFileDownloadData", fileDto, {
            headers: {
                unblockUI: true,
                "Content-type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                "X-Frame-Options":"DENY",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
        })
        .catch(function (error) {
            if (error && error.status && (error.status === 429)) {
            } else {
                toastr.error("" + error);
            }
        });
    };
  }
  

export function exportToExcelCall(searchDto) {
    return function (dispatch) {
        axios
        .post("/monthlyFileUpload/exportUserDetails", searchDto, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            "Content-type": "application/json",
            Accept: "application/json",
            Pragma: "no-cache",
            "X-Frame-Options":"DENY",
            'Authorization': 'Bearer ' + getToken()
          },
          responseType: "arraybuffer" 
        })
        .then(function (response) {  
            FileDownload(response.data, decodeURI(response.headers["filename"].replace(/\+/g, " ")));  
          }) 
        .catch(function (error) {
            if (error && error.status && (error.status === 429)) {
            } else {
                toastr.error(I18n.t("UserManagement.error_message"));
            }
        });
    };
  }

 export function fetchScrollableWidgetDataNAS(widgetName, queryDTO, onSuccess,onFailure) {
    return function (dispatch) {
        axios.post('/dashboard/widget/' + widgetName, queryDTO,
            {
                headers: {
                    unblockUI: true,
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Pragma: "no-cache",
                    'Authorization': 'Bearer ' + getToken()
                }
            })
            .then(response => {
                if (response) {
                  onSuccess(response.data)
                }
              })
              .catch(function (error) {
                if (error && error.status && (error.status === 429)) {
                } else {
                    onFailure(error)
                }
              });
    }
}

/** Get call for fetching Cycles */
export function getCycle(onSuccess,onFailure) {
    return function (dispatch) {
        var url = "/dashboard/cycles/all";
        axios.get(url,{
            contentType: "application/pdf",
            headers: {
                unblockUI: true,
                "Content-type": "application/json",
                Accept: "application/json",
                'Authorization': 'Bearer ' + getToken()
            }
          })
          .then(data => {
            if (data?.data?.length > 0) {
              onSuccess(data?.data)
              dispatch({
                type: "CYCLE_DATA_LIST",
                payload: data.data
              });
            } else {
              onFailure(data?.status)
            }
          })
          .catch(function (error) {
            if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
          });
      };
  }

  /** Progress per NMSC call */
export function fetchProgressPerNmscBar(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_PROGRESS_PER_NMSC, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

  /** Progress per NMSC call */
export function fetchAvgScorePerChapter(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_AVERAGE_SCORE_PER_CHAPTER, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

  /** Progress per NMSC call */
export function fetchScorePerSubquestion(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_SCORE_PER_SUBQUESTION, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

  /** Delear network status */
export function fetchDealerNetworkStatus(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_DEALER_NETWORK_STATUS, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

  /** Delear network status */
export function fetchDealerProgressPerLocation(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_DEALER_PROGRESS_PER_LOCATION, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

/** Action Items in progress for NAS dealer dashboard*/
export function fetchDealerActionItemReport(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_ACTION_ITEM_REPORT, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

/** Kiazen overview */
export function fetchKaizenOverview(onSuccess, onFailure, data) {
    return function (dispatch) {
        axios.post(DASHBOARD_WIDGET_KAIZEN_OVERVIEW, data, {
            headers: {
                unblockUI: true,
                "Content-Type": "application/json",
                Accept: "application/json",
                Pragma: "no-cache",
                'Authorization': 'Bearer ' + getToken()
            }
        })
        .then(response => {
            if (response) {
                onSuccess(response.data);
            }
        })
        .catch(function (error) {
           if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
        });
    }
}

/** Get call for fetching A2D filter options */
export function getA2DFilters(onSuccess,onFailure) {
    return function (dispatch) {
        var url = DASHBOARD_WIDGET_A2D_FILTERS;
        axios.get(url,{
            contentType: "application/pdf",
            headers: {
                unblockUI: true,
                "Content-type": "application/json",
                Accept: "application/json",
                'Authorization': 'Bearer ' + getToken()
            }
          })
          .then(data => {
            if (data?.data?.length > 0) {
              onSuccess(data?.data)
            } else {
              onFailure(data?.status)
            }
          })
          .catch(function (error) {
            if (error && error.status && (error.status === 429)) {
            } else {
                onFailure(error)
            }
          });
      };
  }